import RegisterPasien from "../../components/RegisterPasien/LoginOnline";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
